var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _path9, _path10, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path11, _path12, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path13, _path14, _line3, _line4, _line5, _line6, _line7, _line8, _rect13, _rect14, _rect15, _path15, _rect16, _rect17, _rect18, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 353,
    viewBox: "0 0 637 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.411 218.143L340.899 132.198C340.826 131.005 341.592 128.796 345.244 129.513L516.98 129.513C518.746 129.14 522.944 129.692 525.608 134.884L569.522 195.314C570.874 197.179 574.397 200.909 577.668 200.909L634.673 200.909",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.185 218.367L295.674 132.341C295.761 131.146 295.019 128.935 291.356 129.652L119.483 129.652C117.72 129.279 113.512 129.832 110.787 135.03L66.1513 195.531C64.7766 197.398 61.2087 201.133 57.9349 201.133L0.884697 201.133",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294.631 317.069L294.59 324.231C294.664 325.276 294.188 327.365 291.686 327.365L221.693 327.365C221.052 327.365 219.295 326.111 217.399 321.098C216.983 319.997 215.025 315.175 212.046 307.893M0.766824 221.948L20.8507 221.948M138.169 189.943L138.148 193.524L138.19 186.138M138.169 189.943L149.533 189.943M138.169 189.943L126.804 189.943M149.533 189.943L160.898 189.943C163.015 189.943 164.493 192.33 164.967 193.524C175.171 218.249 191.792 258.563 203.6 287.302M149.533 189.943L149.513 193.524L149.555 186.138M126.804 189.943L115.439 189.943C113.997 189.793 110.434 190.301 107.722 193.524L97.1883 205.945M126.804 189.943L126.783 193.524L126.825 186.138M97.1883 205.945L86.6549 218.367C85.4455 219.561 82.6419 221.948 81.1025 221.948L61.0186 221.948M97.1883 205.945L107.651 205.945L86.7255 205.945M40.9347 221.948L40.908 226.648M40.9347 221.948L61.0186 221.948M40.9347 221.948L20.8507 221.948M61.0186 221.948L60.9919 226.648M20.8507 221.948L20.8241 226.648M212.046 307.893L223.728 307.893M212.046 307.893C210.804 304.858 209.386 301.396 207.827 297.597M207.827 297.597L223.786 297.597M207.827 297.597C206.51 294.387 205.094 290.937 203.6 287.302M203.6 287.302L223.845 287.302",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.858 317.069L339.818 324.231C339.732 325.276 340.185 327.365 342.686 327.365L412.679 327.365C413.321 327.365 415.092 326.111 417.044 321.098C417.473 319.997 419.486 315.175 422.548 307.893M634.802 221.948L614.718 221.948M497.764 189.943L497.743 193.524L497.785 186.138M497.764 189.943L486.399 189.943M497.764 189.943L509.129 189.943M486.399 189.943L475.034 189.943C472.917 189.943 471.413 192.33 470.925 193.524C460.44 218.249 443.362 258.563 431.227 287.302M486.399 189.943L486.379 193.524L486.421 186.138M509.129 189.943L520.494 189.943C521.938 189.793 525.494 190.301 528.17 193.524L538.562 205.945M509.129 189.943L509.108 193.524L509.15 186.138M538.562 205.945L548.955 218.367C550.151 219.561 552.927 221.948 554.467 221.948L574.55 221.948M538.562 205.945L528.1 205.945L549.025 205.945M594.634 221.948L594.608 226.648M594.634 221.948L574.55 221.948M594.634 221.948L614.718 221.948M574.55 221.948L574.524 226.648M614.718 221.948L614.692 226.648M422.548 307.893L410.866 307.893M422.548 307.893C423.824 304.858 425.282 301.396 426.883 297.597M426.883 297.597L410.924 297.597M426.883 297.597C428.236 294.387 429.692 290.937 431.227 287.302M431.227 287.302L410.983 287.302",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M318.374 202.028L319.381 24.7674C319.385 24.0213 319.874 22.5292 321.799 22.5292L524.081 22.5292C526.326 22.6039 530.819 21.9921 530.836 18.9482C530.853 15.9043 530.899 7.8321 530.92 4.17647C530.845 3.28121 531.272 1.49069 533.581 1.49069L625.532 1.1582",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M317.867 202.028L318.37 113.398L318.873 24.7674C318.877 24.0213 318.406 22.5292 316.484 22.5292L114.509 22.5292C112.267 22.6039 115.879 21.8119 115.897 18.7681C115.914 15.7242 115.96 7.65196 115.98 3.99632C116.066 3.10106 107.568 1.49069 105.262 1.49069L11.0455 1.31055",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M317.623 337.884L317.578 345.941C317.406 347.881 318.122 351.76 322.355 351.76L497.218 351.76C498.5 351.909 501.984 351.044 505.666 346.389L563.321 274.32C564.37 273.052 566.902 270.516 568.634 270.516L634.298 270.516",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M316.622 337.884L316.576 345.941C316.725 347.881 315.966 351.76 311.732 351.76L136.87 351.76C135.586 351.909 132.112 351.044 128.482 346.389L71.6458 274.32C70.6107 273.052 68.1076 270.516 66.3758 270.516L0.712205 270.516",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 537.79 22.7529)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 97.6548,
    y2: -0.5,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 2.37842 22.7532)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M477.572 351.582L497.572 351.655C498.571 351.825 501.373 351.269 504.586 347.681C507.799 344.092 520.994 327.24 527.19 319.263",
    stroke: "url(#paint0_linear_416_1290)",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M156.067 351.91L136.067 351.837C135.066 352 132.268 351.423 129.082 347.812C125.895 344.2 112.823 327.252 106.686 319.23",
    stroke: "url(#paint1_linear_416_1290)",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 50.1352,
    transform: "matrix(0.00364554 -0.999993 0.999957 0.00932149 158.199 23.4629)",
    fill: "url(#paint2_linear_416_1290)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 50.1352,
    transform: "matrix(0.00364552 -0.999993 -0.999998 0.00203054 492.333 24.207)",
    fill: "url(#paint3_linear_416_1290)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 21.7721,
    transform: "matrix(-0.00364558 0.999993 -0.999957 -0.00932152 224.58 285.743)",
    fill: "url(#paint4_linear_416_1290)",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 21.7721,
    transform: "matrix(-0.00364549 0.999993 0.999998 -0.00203057 410.808 286.422)",
    fill: "url(#paint5_linear_416_1290)",
    fillOpacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 16.772,
    transform: "matrix(-0.00364558 0.999993 -0.999957 -0.00932152 224.54 296.783)",
    fill: "url(#paint6_linear_416_1290)",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 16.772,
    transform: "matrix(-0.00364549 0.999993 0.999998 -0.00203057 410.768 297.462)",
    fill: "url(#paint7_linear_416_1290)",
    fillOpacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.622 189.802L160.621 189.926C161.787 190.263 164.613 192.24 166.594 197.448L190.882 255.536",
    stroke: "url(#paint8_linear_416_1290)",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M509.125 190.196L476.125 190.076C474.957 190.405 472.116 192.361 470.097 197.554L445.386 255.464",
    stroke: "url(#paint9_linear_416_1290)",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    transform: "matrix(0.999993 0.00364553 0.00364553 -0.999993 293.39 253.91)",
    fill: "url(#paint10_linear_416_1290)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 293.35,
    y: 264.91,
    width: 2,
    height: 15,
    transform: "rotate(0.208874 293.35 264.91)",
    fill: "url(#paint11_linear_416_1290)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    transform: "matrix(0.999993 0.00364553 0.00364553 -0.999993 317.39 253.998)",
    fill: "url(#paint12_linear_416_1290)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 317.349,
    y: 264.998,
    width: 2,
    height: 26,
    transform: "rotate(0.208874 317.349 264.998)",
    fill: "url(#paint13_linear_416_1290)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 8,
    transform: "matrix(0.999993 0.00364553 0.00364553 -0.999993 339.39 254.078)",
    fill: "url(#paint14_linear_416_1290)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 339.349,
    y: 265.078,
    width: 2,
    height: 15,
    transform: "rotate(0.208874 339.349 265.078)",
    fill: "url(#paint15_linear_416_1290)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.84 129.791L119.34 129.775C118.008 129.437 114.339 130.156 110.318 135.742L87.1711 166.999",
    stroke: "url(#paint16_linear_416_1290)",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M512.673 129.791L517.173 129.775C518.505 129.437 522.174 130.156 526.195 135.742L549.342 166.999",
    stroke: "url(#paint17_linear_416_1290)",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 127.134,
    y1: 186.304,
    x2: 127.109,
    y2: 193.304,
    stroke: "#D9D9D9"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 138.134,
    y1: 186.344,
    x2: 138.109,
    y2: 193.344,
    stroke: "#B7B7B7"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 149.134,
    y1: 186.384,
    x2: 149.108,
    y2: 193.384,
    stroke: "#929292"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 7,
    y2: -0.5,
    transform: "matrix(-0.00364549 0.999993 0.999993 0.00364549 509.65 186.778)",
    stroke: "#D9D9D9"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 7,
    y2: -0.5,
    transform: "matrix(-0.00364549 0.999993 0.999993 0.00364549 498.65 186.738)",
    stroke: "#B7B7B7"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 7,
    y2: -0.5,
    transform: "matrix(-0.00364549 0.999993 0.999993 0.00364549 487.65 186.698)",
    stroke: "#929292"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 620.042 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 605.118 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 590.194 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M575.265 193.822C575.268 193.41 575.604 193.076 576.016 193.076L584.342 193.076C585.447 193.076 586.337 193.971 586.331 195.076L586.327 195.707C586.322 196.726 585.491 197.552 584.471 197.552L578.974 197.552C576.914 197.552 575.254 195.882 575.265 193.822Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 16.3359 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 31.2603 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 46.1846 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1047 193.822C61.107 193.41 60.7749 193.076 60.3628 193.076L52.0361 193.076C50.9316 193.076 50.0311 193.971 50.0248 195.076L50.0212 195.707C50.0154 196.726 50.837 197.552 51.8562 197.552L57.3532 197.552C59.4134 197.552 61.093 195.882 61.1047 193.822Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_416_1290",
    x1: 526.192,
    y1: 318.759,
    x2: 489.575,
    y2: 350.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_416_1290",
    x1: 107.687,
    y1: 318.733,
    x2: 144.071,
    y2: 350.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_416_1290",
    x1: 0.909126,
    y1: 0,
    x2: 0.909126,
    y2: 50.1352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_416_1290",
    x1: 0.909126,
    y1: 0,
    x2: 0.909126,
    y2: 50.1352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_416_1290",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 21.7721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_416_1290",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 21.7721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_416_1290",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 16.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_416_1290",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 16.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_416_1290",
    x1: 128.62,
    y1: 190.309,
    x2: 181.994,
    y2: 194.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_416_1290",
    x1: 508.123,
    y1: 190.693,
    x2: 454.723,
    y2: 194.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_416_1290",
    x1: 1,
    y1: 8,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_416_1290",
    x1: 294.35,
    y1: 279.91,
    x2: 294.35,
    y2: 264.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_416_1290",
    x1: 1,
    y1: 14,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_416_1290",
    x1: 318.349,
    y1: 290.998,
    x2: 318.349,
    y2: 264.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_416_1290",
    x1: 1,
    y1: 8,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_416_1290",
    x1: 340.349,
    y1: 280.078,
    x2: 340.349,
    y2: 265.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_416_1290",
    x1: 110.326,
    y1: 133.242,
    x2: 121.749,
    y2: 131.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_416_1290",
    x1: 526.187,
    y1: 133.242,
    x2: 514.764,
    y2: 131.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame11);
export default __webpack_public_path__ + "static/media/card1-frame11.29bb89080dfcbf5ae8753153f9d58c9a.svg";
export { ForwardRef as ReactComponent };